// eslint-disable-next-line no-restricted-imports
import { MenuItem } from '@mui/material';

import { CSSObject, styled } from '../styled';
import { Colors } from '../theme';

export const MenuItemStyled = styled(MenuItem)(({ color, theme }) => ({
  color: color ?? Colors.black,
  padding: '8px 12px',

  transition: theme.transitions.create(['background']),

  '&:hover': {
    backgroundColor: Colors.gray100,
  } as CSSObject,

  '.menu-item-link': {
    padding: '5px 0',
  },
}));
